module.exports = __webpack_public_path__ + "assets/photos/memories/frame-3--a342868a1f6917262554d22b98a9970b.jpg";